import { Coverage } from "~/application/types";
import { CoverageDTO } from "../dtos";
import { mapViolatedPoliciesDTO } from "./mapViolatedPoliciesDTO";

export const mapVehicleCoverageDTO = (data: CoverageDTO): Coverage => {
  return {
    id: data.id,
    type: data.type,
    price: parseFloat(data.price),
    description: data.description,
    totalPriceWithCoverage: parseFloat(data?.total_price_with_coverage),
    violatedPolicies: mapViolatedPoliciesDTO(data.violated_policies),
    additionalCoverages: data.additional_coverages
      ? data.additional_coverages
          ?.slice()
          .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
          .map(mapVehicleCoverageDTO)
      : undefined,
  };
};
